export default __webpack_public_path__ + "static/AM-start-Adrine-Mkrtchyan-54a63bd7e5387e953dde7a510d430fc0.png";